import { useLocalize } from './useLocalizeContext'

export default function withLocalize(Component: any) {
  const Context = (props: any) => {
    return <Component localizer={useLocalize()} {...props} />
  }
  return Context
}
